// Catalog of tags an owner can apply to an online order. Adding a new entry
// here surfaces it in every owner UI (detail action area + history list).
// The server keeps a matching allow-list — see ONLINE_ORDER_TAGS in
// libs/online-order/src/online-order-owner/online-order-owner.service.ts
export interface OnlineOrderTagDef {
  key: string;
  label: string;
  // Tailwind color hint used by the badge component.
  color: 'orange' | 'red' | 'blue' | 'green' | 'gray';
}

export const ONLINE_ORDER_TAGS = {
  RECHECK: { key: 're-check', label: 'Re-check', color: 'orange' },
  PAYPAL: { key: 'paypal', label: 'PayPal', color: 'blue' },
} as const satisfies Record<string, OnlineOrderTagDef>;

export const ONLINE_ORDER_TAG_LIST: readonly OnlineOrderTagDef[] = Object.values(ONLINE_ORDER_TAGS);

export function getOnlineOrderTagDef(key: string): OnlineOrderTagDef | undefined {
  return ONLINE_ORDER_TAG_LIST.find((t) => t.key === key);
}

// Resolves a list of stored tag keys to their catalog definitions, dropping
// any unknown keys (e.g. a tag removed from the catalog but still on old orders).
export function resolveOnlineOrderTags(keys: readonly string[]): OnlineOrderTagDef[] {
  return keys.map(getOnlineOrderTagDef).filter((tag): tag is OnlineOrderTagDef => !!tag);
}

// Solid dot color used in menus to indicate a tag's identity.
export const ONLINE_ORDER_TAG_DOT_COLOR: Record<OnlineOrderTagDef['color'], string> = {
  orange: 'bg-orange-500',
  red: 'bg-red-500',
  blue: 'bg-blue-500',
  green: 'bg-green-500',
  gray: 'bg-gray-500',
};
